module.exports = __webpack_public_path__ + "img/testResultsBannerRed.ba941ee8.jpg";